module.exports = __webpack_public_path__ + "img/global_logo_200x200.42a5b955.jpg";